/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import Button from "../../ui/Button";
import SelectWithPills from "../../ui/SelectWithPills";
import { MdClose } from "react-icons/md";
import Input from "../../ui/Input";
import Select from "../../ui/Select";
import RightEditorSectionOffer from "./RightSectionOffer";
import useFetch from "../../../hooks/useFetch";
import { useSelector } from "react-redux";
import { selectCid } from "../../../features/companyid";
import { toast } from "react-toastify";
import { FaSpinner } from "react-icons/fa";
import axiosInstance from "../../../axiosInstance";
import {
  formatVariablesFromHTML,
  unformatVariablesToHTML,
} from "../../../utils/settings";
import CloseUnsaved from "./CloseUnsaved";
import { OFFER_LETTER_CONSTANTS, OFFER_LETTER_MAPPER } from "../../../constants/common";

const OfferModal = ({ onClose, isEdit, uuid }) => {
  const [variables, setVariables] = useState(Object.keys(OFFER_LETTER_MAPPER));

  const [closeConfirmationModal, setCloseConfirmationModal] = useState(false);

  const [formData, setFormData] = useState({
    name: "",
    description: "",
    mapped_salary: "",
    mapped_salary_name: "",
    offer_body: "",
  });
  const cid = useSelector(selectCid);
  const [activeTab, setActiveTab] = useState("edit");
  const { refetch, isLoading } = useFetch(
    "/v2/template/create",
    {
      method: "POST",
      data: {
        type: "offer",
        companyid: cid,
        offer_template: {
          name: formData.name,
          description: formData.description,
          mapped_salary: formData.mapped_salary,
          mapped_salary_name: formData.mapped_salary_name,
          offer_body: formatVariablesFromHTML(formData.offer_body),
          variables: variables,
        },
      },
    },
    false
  );

  const { refetch: updateRefetch, isLoading: updateIsLoading } = useFetch(
    "/v2/template/update",
    {
      method: "PATCH",
      data: {
        type: "offer",
        companyid: cid,
        uuid: uuid,
        name: formData.name,
        description: formData.description,
        mapped_salary: formData.mapped_salary,
        mapped_salary_name: formData.mapped_salary_name,
        offer_body: formatVariablesFromHTML(formData.offer_body),
        variables: variables,
      },
    },
    false
  );

  const {
    refetch: getTemplate,
    isLoading: getTemplateIsLoading,
    data: template,
  } = useFetch(
    "/v2/template/get/" + uuid + "/" + cid,
    {
      method: "GET",
    },
    false
  );

  const { data: salaryTemplates } = useFetch(
    "/v2/template/getall/" + cid + "?type=salary"
  );

  useEffect(() => {
    if (isEdit && cid && uuid) {
      (async () => {
        try {
          await getTemplate().then(() => {
            setFormData(template);
          });
        } catch (err) {
          console.error("❌ Failed to fetch template:", err);
        }
      })();
    }
  }, [isEdit, cid, uuid]);

  useEffect(() => {
    if (template) {
      setFormData({
        ...template,
        offer_body: unformatVariablesToHTML(template.offer_body),
      });
    }
  }, [template]);

  const isDisabled = () => {
    if (activeTab === "edit") {
      return formData.name === "" || formData.description === "";
    }
  };

  if (getTemplateIsLoading) {
    return (
      <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-60 z-50 p-4">
        <div className="bg-white relative flex justify-center items-center w-full h-80 max-w-5xl rounded-xl shadow-2xl animate-fadeIn">
          <FaSpinner className="animate-spin mr-2 h-20 w-20" />
        </div>
      </div>
    );
  }

  return (
    <div className="fixed inset-0 flex text-start items-center justify-center bg-black bg-opacity-60 z-50 p-4">
      <div className="bg-white relative w-full max-w-5xl rounded-xl shadow-2xl animate-fadeIn">
        <Button
          variant="icon"
          size="iconSm"
          className="!absolute top-4 right-4 border rounded-full"
          onClick={onClose}
        >
          <MdClose />
        </Button>

        {
          closeConfirmationModal ?
            <CloseUnsaved onClose={onClose} onCancel={() => setCloseConfirmationModal(false)} /> :
            <>
              {/* Content */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 p-6 pr-2">
                {/* Left Side - Form */}
                <div className="flex flex-col gap-4">
                  <Input
                    label={"Template Name*"}
                    name={"template_name"}
                    lableClass={"text-primaryBlack"}
                    className={
                      "text-sm disabled:bg-gray-100 disabled:border-gray-200 disabled:opacity-50"
                    }
                    placeholder={"Template Name"}
                    disabled={activeTab === "preview"}
                    value={formData.name}
                    onChange={(e) =>
                      setFormData({ ...formData, name: e.target.value })
                    }
                    maxLength={100}
                  />

                  <Input
                    label={"Description*"}
                    name={"description"}
                    lableClass={"text-primaryBlack"}
                    className={
                      "text-sm disabled:bg-gray-100 disabled:border-gray-200 disabled:opacity-50"
                    }
                    placeholder={"Description"}
                    disabled={activeTab === "preview"}
                    value={formData.description}
                    onChange={(e) =>
                      setFormData({ ...formData, description: e.target.value })
                    }
                    maxLength={300}
                  />

                  <Select
                    label={"Choose Salary Template"}
                    name={"salaryTemplate"}
                    labelClass={"!text-primaryBlack"}
                    className={"text-sm"}
                    options={salaryTemplates?.templates?.map((opt) => ({
                      label: opt.name,
                      value: opt.uuid,
                    }))}
                    placeholder={"Select a template"}
                    disabled={activeTab === "preview"}
                    value={formData.mapped_salary}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        mapped_salary_name: salaryTemplates?.templates?.find(
                          (opt) => opt.uuid === e.target.value
                        )?.name,
                        mapped_salary: e.target.value,
                      })
                    }
                  />

                  {/* <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Sample Template
              </label>
              <div
                className={`flex items-center border border-gray-300 rounded-md overflow-hidden ${
                  activeTab === "preview" ? "opacity-50 border-gray-200" : ""
                }`}
              >
                <span
                  className={`flex-1 px-3 py-3 text-gray-500 text-sm truncate ${
                    activeTab === "preview" ? " bg-gray-100" : ""
                  }`}
                >
                  {fileName || "No file chosen"}
                </span>

                <label
                  htmlFor="fileUpload"
                  className={`bg-gray-900 text-white text-sm font-medium px-5 py-3 hover:bg-gray-800 ${
                    activeTab === "preview"
                      ? "cursor-not-allowed"
                      : "cursor-pointer"
                  }`}
                >
                  {file ? (
                    <FaSpinner className="animate-spin h-5 w-5" />
                  ) : fileName ? (
                    "Change"
                  ) : (
                    "Upload"
                  )}
                </label>

                <input
                  id="fileUpload"
                  type="file"
                  accept=".pdf,.doc,.docx"
                  className="hidden disabled:bg-gray-100 disabled:opacity-50"
                  disabled={activeTab === "preview"}
                  onChange={async (e) => {
                    const selectedFile = e.target.files?.[0];
                    if (!selectedFile) return;

                    setFileName(selectedFile.name); // ✅ update UI immediately
                    setFile(true);

                    const form = new FormData();
                    form.append("file", selectedFile);
                    form.append("companyid", cid);

                    try {
                      const res = await axiosInstance("/v2/template/file", {
                        method: "POST",
                        data: form,
                        headers: {
                          "Content-Type": "multipart/form-data",
                        },
                      });

                      const data = res.data;
                      console.log("📂 File upload response:", data);

                      // ✅ Update editor content
                      setFormData((prev) => ({
                        ...prev,
                        offer_body: data.html_text,
                      }));

                      toast.success("File uploaded successfully!");
                    } catch (err) {
                      console.error("❌ File upload error:", err);
                      toast.error("Failed to upload file");
                      // If upload fails, reset file name
                      setFileName("");
                    } finally {
                      // ✅ Stop spinner
                      setFile(false);
                    }
                  }}
                />
              </div>
            </div> */}

                  <SelectWithPills
                    label="Add Variables"
                    options={Object.keys(OFFER_LETTER_MAPPER)}
                    value={[...variables]}
                    onChange={setVariables}
                    editNotAllowed={true}
                  />
                </div>

                <RightEditorSectionOffer
                  quillBody={formData.offer_body}
                  variableOptions={variables}
                  activeTab={activeTab}
                  setActiveTab={setActiveTab}
                  setFormData={setFormData}
                  formData={formData}
                />
              </div>

              {/* Footer */}
              <div className="flex justify-center border-t bg-[#F8F9FC] px-6 py-4 rounded-b-xl gap-3">
                <Button
                  variant="secondary"
                  onClick={() => setCloseConfirmationModal(true)}
                  className="text-sm"
                  disabled={isLoading || updateIsLoading}
                >
                  Cancel
                </Button>
                <Button
                  variant="black"
                  disabled={isDisabled()}
                  className="text-sm"
                  loading={isLoading || updateIsLoading}
                  onClick={async () => {
                    if (isEdit) {
                      updateRefetch()
                        .then(() => {
                          onClose();
                          window.location.reload();
                        })
                        .catch(() =>
                          toast.error("Something went wrong! Please try again.")
                        );
                    } else {
                      refetch()
                        .then(() => {
                          onClose();
                          window.location.reload();
                        })
                        .catch(() =>
                          toast.error("Something went wrong! Please try again.")
                        );
                    }
                  }}
                >
                  Save
                </Button>
              </div>
            </>
        }

      </div>
    </div>
  );
};

export default OfferModal;

